import { Col, Form } from "react-bootstrap";

interface SearchBoxProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const SearchBox = ({
  value,
  onChange,
  placeholder = "Search...",
}: SearchBoxProps) => {
  const handleClear = () => {
    // Create a synthetic event to reuse onChange
    onChange({
      target: { value: "" },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <>
      <style>
        {`.search-box {
  position: relative;
}

.search-box .form-control.search {
  height: 32px;
  min-height: 32px;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 13px;
}

.clear-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
}

.clear-icon:hover {
  color: #dc3545;
}
`}
      </style>
      <Col xs={12} md={12} lg={4} xl={5}>
        <div className="search-box position-relative">
          <Form.Control
            type="text"
            className="search pe-5"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />

          {/* 🔍 Search icon */}
          <i className="ri-search-line search-icon"></i>

          {/* ❌ Clear icon */}
          {value && (
            <i
              className="ri-close-line clear-icon"
              onClick={handleClear}
              role="button"
              aria-label="Clear search"
            />
          )}
        </div>
      </Col>
    </>
  );
};

export default SearchBox;
